import React from "react";
import { Routes, Route } from "react-router-dom";

// Components
import Header from "./components/Header";

import About from "./components/About";
import GallerySection from "./components/GallerySection";
import Skills from "./components/Skills";
import Interview from "./components/Interview";
import Testimonial from "./components/Testimonial";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Copyright from "./components/Copyright";
import Home from "./components/Home";

const App = () => {
  return (
    <div className="max-w-[1920px] mx-auto overflow-hidden bg-white">

      {/* Header always visible */}
      <Header />

      {/* Pages Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<GallerySection />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/interview" element={<Interview />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      {/* Footer always visible */}
      <Footer />
      <Copyright />

    </div>
  );
};

export default App;